const DoubleDoor = props => (
  <svg {...props} width="24px" height="12px" viewBox="0 0 24 12">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-526.000000, -97.000000)">
      <g id="DoubleDoor" transform="translate(527.000000, 98.000000)" stroke="#313F4C" strokeWidth="1.5">
        <path d="M0,0 L11,0 C11,0 11,11 0,11" id="Page-1-Copy" transform="translate(5.500000, 5.500000) rotate(-90.000000) translate(-5.500000, -5.500000) "></path>
        <path d="M22,11 L22,0 C22,0 11,0 11,11" id="Page-1-Copy-2"></path>
      </g>
    </g>
  </svg>
);

export default DoubleDoor;
